module.exports = __webpack_public_path__ + "static/media/landing page (1).f51fc268.png";